@if (itemTree) {
  <div>
    <mat-card appearance="outlined" class="mb-3">
      <mat-card-header class="item-tree-header">
        <h1>
          <mat-card-title>{{ item.name }}</mat-card-title>
          <button mat-icon-button
            aria-label="Edit name"
            i18n-aria-label
            (click)="onEdit()">
            <mat-icon>edit</mat-icon>
          </button>
        </h1>
        <div class="text-right">
          <button mat-flat-button color="primary" (click)="onSave()" i18n>Save</button>
        </div>
      </mat-card-header>
      <mat-card-content>
        <p class="subtitle-help-text" i18n>
        Please name the item you are creating. You can create a single item or a group of multiple options.
      </p>
        <ul class="list-unstyled">
          <li class="subtitle-text">
            <ng-container i18n>Booking status</ng-container>: {{ itemTree.bookingStatus }}
          </li>
          <li class="subtitle-text">
            <ng-container i18n>State</ng-container>: {{ itemTree.state }}
            <eas-editor-booking-item-state-action [bookingItem]="bookingItem"></eas-editor-booking-item-state-action>
          </li>
        </ul>
        @if (bookingItem.doc.translationInfo) {
          <eas-translation-info-list
            [translationInfo]="bookingItem.doc.translationInfo">
          </eas-translation-info-list>
        }
      </mat-card-content>
    </mat-card>
    <mat-card appearance="outlined" class="mb-3">
      <mat-card-header>
        <mat-card-title>
          <h2 i18n>
          Integration information
        </h2>
        </mat-card-title>
        <mat-card-subtitle>
          <div class="subtitle-help-text" i18n>
          This shows status messages from any integration services installed.
        </div>
          @if (itemTree.integrationInfo !== null) {
            <ul class="subtitle-text">
              @for (descriptionLine of itemTree.integrationInfo.description; track descriptionLine) {
                <li>
                  <span [ngClass]="{'met': descriptionLine.type === 'success', 'unmet': descriptionLine.type === 'error'}">
                    {{ descriptionLine.message }}
                  </span>
                </li>
              }
              @if (itemTree.integrationInfo.usage && itemTree.integrationInfo.usage.new) {
                <li>
                  <span i18n>Pending {{ itemTree.integrationInfo.usage.new }} actions</span>
                </li>
              }
            </ul>
          }
        </mat-card-subtitle>
      </mat-card-header>
    </mat-card>
    <eas-editor-booking-item></eas-editor-booking-item>
  </div>
}

<ng-template #loading>
  <h1 i18n>Loading...</h1>
</ng-template>
